export const JOB_TYPE_LABELS = {
  survey: "Survey",
  photo: "Photography",
  inspection: "Inspection",
  spraying: "Spraying",
  seeding: "Seeding",
  mapping: "Mapping",
  search_rescue: "Search & Rescue",
};

export const STATUS_STYLES = {
  scheduled: { label: "Scheduled", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", dot: "#3B82F6" },
  in_progress: { label: "In Progress", bg: "bg-lime-50", text: "text-lime-800", border: "border-lime-300", dot: "#84CC16" },
  completed: { label: "Completed", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", dot: "#10B981" },
  cancelled: { label: "Cancelled", bg: "bg-red-50", text: "text-red-700", border: "border-red-200", dot: "#EF4444" },
};

export const fmtTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit", timeZone: "Australia/Brisbane" });
  } catch { return ""; }
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short", timeZone: "Australia/Brisbane" });
  } catch { return ""; }
};
